<template>
  <mdb-container>
     <timer-modal
      :modal-state="activeModal"
      :duration="duration"
      @close="close"
      @answerYes="answerYes"
    />
    <h4 class="text-center mt-3 mb-4 font-weight-bold">Zimmerübersicht</h4>
    <mdb-row class="justify-content-sm-center">
      <div class="d-flex justify-content-center">
        <mdb-spinner big v-if="loading"/>
      </div>
      <mdb-col
        lg="4"
        md="6"
        sm="12"
        class="mt-3"
        v-for="(room, index) in rooms"
        :key="index"
      >
      <div
        @click="selectRoom(room)"
      >
        <mdb-card
          class="d-flex flex-row pointer"
        >
          <mdb-view
            hover
            class="w-25 d-flex"
            style="border-top-left-radius: .25rem; border-bottom-left-radius: .25rem;"
          >
            <a
              href="#!"
              class="d-flex w-100 justify-content-center align-item-center blue-gradient"
            >
              <mdb-icon icon="home" class="d-inline mt-auto mb-auto text-white" size="3x" />
              <mdb-mask flex-center waves overlay="white-slight" />
            </a>
          </mdb-view>
          <mdb-card-body>
            <a class="activator mr-4">
              <mdb-icon
                color="blue"
                icon="arrow-circle-right"
              />
            </a>
            <mdb-card-title class="blue-text font-weight-bold">
              {{ room.Zimmer }}
              <mdb-icon
                v-if="currentRoom == room.Id"
                icon="star"
                size="sm"
                class="amber-text"
              />
            </mdb-card-title>
            <hr/>
            <mdb-card-text>
              <p class="mb-0">
                <mdb-icon icon="user" /> <strong>{{ room.Gastname }}</strong>
              </p>
              <p class="mb-0">
                <mdb-badge
                  v-if="room.Pflegestufe"
                  color="info"
                  class="py-1"
                  style="box-shadow: 0 0 0 0;"
                  pill
                >
                  {{ room.Pflegestufe }}
                </mdb-badge>
                <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                  <mdb-badge
                    color="info"
                    class="ml-2"
                    style="box-shadow: 0 0 0 0;"
                    slot="reference"
                    pill
                  >
                    <mdb-icon
                      icon="calendar-alt"
                      class="mr-1"
                    /> {{ formatDate(room.Aufnahme) }}
                  </mdb-badge>
                  <span slot="tip">Aufnahmedatum</span>
                </mdb-tooltip>
              </p>
            </mdb-card-text>
          </mdb-card-body>
        </mdb-card>
      </div>
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<script>
import utils from '@/mixins/Utils'
import { mapActions } from 'vuex'
import {
  mdbContainer,
  mdbCol,
  mdbRow,
  mdbCard,
  mdbCardBody,
  mdbMask,
  mdbCardTitle,
  mdbCardText,
  mdbView,
  mdbIcon,
  mdbBadge,
  mdbTooltip,
  mdbSpinner,

} from 'mdbvue';
const TimerModal = () => import('@/components/modals/TimerModal')
export default {
  name: 'Rooms',
  mixins: [utils()],

  components : {
    mdbContainer,
    mdbCol,
    mdbRow,
    mdbCard,
    mdbCardBody,
    mdbView,
    mdbIcon,
    mdbMask,
    mdbCardTitle,
    mdbCardText,
    mdbBadge,
    mdbTooltip,
    mdbSpinner,
    TimerModal,
  },

  data () {
    return {
      rooms: [],
      loading: false,
      currentRoom: null,
      activeModal: false,
      timer : 0,
      duration: 10,
      interval: null,
      timeout: null
    }
  },

  created() {
    this.loadRooms()
    this.timer = localStorage.getItem('timeout_overview')
  },

  watch: {
    activeModal(v) {
      if (v) {
        this.startCountdown()
      }
    }
  },

  mounted () {
    this.showModal()
    window.addEventListener("click", () => {
      window.clearTimeout(this.timeout)
      this.showModal()
    })
    window.addEventListener("scroll", () => {
      window.clearTimeout(this.timeout)
      this.showModal()
    })
    window.addEventListener("keypress", () => {
      window.clearTimeout(this.timeout)
      this.showModal()
    })
    window.addEventListener("mousemove", () => {
      window.clearTimeout(this.timeout)
      this.showModal()
    })
    window.addEventListener("contextmenu", () => {
      window.clearTimeout(this.timeout)
      this.showModal()
    })
  },

  methods: {
    ...mapActions('app', ['setRoom']),
    ...mapActions('auth', ['setRoomDialog', 'resetUser']),

    loadRooms () {
      this.loading = true
      this.$http.get('Dashboard')
        .then(res => {
          this.rooms = res.data.data
          let room = JSON.parse(localStorage.getItem('rooms_dialog'));

          if(room){
            this.setRoomDialog(room);
          }
          else {
            let data = []
            this.rooms.forEach(room => {
              data.push({
                'name': room.Zimmer,
                'status': true
              })
            });
            this.setRoomDialog(data)
          }

          let settingsRoom = localStorage.getItem('settingsRoom')
          this.currentRoom = settingsRoom
        })
        .finally(() => {
          this.loading = false
        })
    },

    selectRoom (room) {
      // set room data to store
      room.Pflegeberichte = null
      localStorage.setItem('room', JSON.stringify(room))
      localStorage.setItem('roomID', room.Id)
      this.setRoom(room)
      localStorage.setItem('dialog_open', room.Zimmer);

      this.$router.push({ path: '/pflegebericht/'+room.Id })
    },

    showModal () {
       this.timeout = setTimeout(() => {
        this.activeModal = true
      }, this.timer)
    },

    startCountdown () {
      if (this.duration > 0) {
        this.interval = setInterval(this.countDown, 1000)
      }
    },

    countDown () {
      if (this.duration === 0) {
        this.activeModal = false
        this.duration = 10
        clearInterval(this.interval)
        this.logout()
      } else {
        this.duration -= 1
      }
    },

    answerYes () {
      this.activeModal = false
      this.duration = 10
      clearInterval(this.interval)
      window.clearTimeout(this.timeout)
      this.showModal()
    },

    close () {
      this.duration = 0
      this.countDown()
    },

    logout() {
      this.resetUser()
      this.$router.push({ name: 'Login' })
    },
  }
}
</script>
